import { render } from "./HeaderScoring.vue?vue&type=template&id=6bbe15c9&scoped=true"
import script from "./HeaderScoring.vue?vue&type=script&lang=js"
export * from "./HeaderScoring.vue?vue&type=script&lang=js"

import "./HeaderScoring.vue?vue&type=style&index=0&id=6bbe15c9&lang=stylus&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bbe15c9"]])

export default __exports__